module.exports = __webpack_public_path__ + "static/WEDDING E&M-409-4f8c5042e298900cd307bd06ad0b86c5.jpg";